import { createFileRoute } from '@tanstack/react-router'
import { CustomersPage } from '@/features/customers/ui/customers-page'
import { PageLayout } from '@/components/page-layout'

export const Route = createFileRoute('/_authenticated/customers')({
	component: () => {
		return (
			<PageLayout data-id='customers-page'>
				<CustomersPage />
			</PageLayout>
		)
	},
})
